import { put, takeLatest, call, delay } from "redux-saga/effects";
import { FETCH_POST_CMND, } from "../constants/identify";
import {
    fetchPostCMNDSuccess,
    fetchPostCMNDFailed,
} from "../actions/identify";
import { fetchPostCMNDApi } from "../apis/identify";
import { STATUS_CODE } from "../constants/commons";
import { isEmpty } from "commons/shared";

function* actionFetchPostCMND(action) {
    try {
        yield delay(500);
        const { params } = action.payload;
        const response = yield call(fetchPostCMNDApi, params);
        const { status, data } = response;
        // console.log("response identify: ", response);
        if (!isEmpty(data)) {
            yield put(fetchPostCMNDSuccess(data));
        } else {
            yield put(fetchPostCMNDFailed(true));
        }
    } catch (error) {
        yield put(fetchPostCMNDFailed(error));
    }
}

export function* watchIdentifyFetch() {
    yield takeLatest(FETCH_POST_CMND, actionFetchPostCMND);
}